




































/* tslint:disable */
import 'bootstrap'
import 'bootstrap-select'
import 'popper.js'
import Vue from 'vue'
import 'vue-select/dist/vue-select.css'
// import "bootstrap-daterangepicker";
import EditAppointmentModalV2 from '@/pmd/components/EditAppointmentModalV2.vue'
import GMBConnectionWarning from '@/pmd/components/GMBConnectionWarning.vue'
import GMBMessagingWarning from '@/pmd/components/GMBMessagingWarning.vue'
import OverusedWarning from '@/pmd/components/agency/billing/OverusedWarning.vue'
import WarningManager from '@/pmd/components/common/WarningManager.vue'
import Overlay from '@/pmd/components/sidebar/Overlay.vue'
import EmailTemplateBuilderModal from '@/pmd/pages/emailBuilder/EmailTemplateBuilderModal'
import { OauthService } from '@/services'
import * as Ux from '@/util/ux_message'
import handlebars from 'handlebars'
import moment from 'moment-timezone'
import postscribe from 'postscribe'
import { mapState } from 'vuex'
import { Company, User, getCountryInfo } from '../models'
import { USER_TYPE as userType } from '../models/user'
import { CompanyState, IframeState, UserState } from '../store/state_models'
import currencyList from '../util/currency'
import ImagePreviewModal from './components/ImagePreviewModal.vue'
import ManualCallStatusModal from './components/ManualCallStatusModal.vue'
import UxMessageModal from './components/util/UxMessageModal.vue'
import UxToaster from './components/util/UxToaster.vue'
import { CustomStorageCleanUp, CustomStorageManager, RouteHelper, Utilities } from './utils/CustomScriptHelper'
import config from '@/config'
import { AgencyproPlusAddonPlan } from '@/models/company'
import { useEmitter } from '@/pmd/composition/useEmitter'
import * as Sentry from "@sentry/vue"
import firebase from 'firebase/compat/app'
import get from "lodash-es/get"
import { Languages, localizationKey } from '../localization'
import { setSentryMeta } from '../plugins/sentry'
import { customLogger } from '../plugins/sentry/customLogger'
import { IntegrationService } from '../services'
import AffiliateService from '../services/AffiliateService'
import { loadFreshChatWidgetScript, loadFreshWorksWidgets } from '../util/freshchat'
import AppReleaseCard from './components/app_release/appReleaseCard.vue'
import AppLoader from './loader/AppLoader.vue'

let timeout: NodeJS.Timer

var userData = {} as any
var companyData = {} as any

// For storing lead and customer count
let leadCount: number
let customerCount: number

loadFreshChatWidgetScript()

const devEnv = ['development', 'staging'].includes(process.env.NODE_ENV || '') && process.env.VUE_APP_DISABLE_PERFORMANCE_DEBUGGER !== 'true'


export default Vue.extend({
  name: 'PMDApp',
  metaInfo() {
    return {
      title: this.company?.name
    }
  },
  components: {
    ImagePreviewModal,
    UxMessageModal,
    UxToaster,
    ManualCallStatusModal,
    OverusedWarning,
    GMBMessagingWarning,
    GMBConnectionWarning,
    WarningManager,
    Overlay,
    EditAppointmentModalV2,
    EmailTemplateBuilderModal,
    CommonConditionalComponents: () => import('@/pmd/components/CommonConditionalComponents.vue'),
    ContentAIModals: () => import('@/pmd/pages/content_ai/ContentAIModals.vue'),
    CopilotDrawer: () => import('@/pmd/pages/copilot/CopilotDrawer.vue'),
    CopilotModal: () => import('@/pmd/pages/copilot/CopilotModal.vue'),
    AppLoader,
    MediaFiles: () => import('@/pmd/pages/medias/MediaFilesModal.vue'),
    AppReleaseCard,
    TrialEndPopup: () => import('@/pmd/components/agency/billing/TrialEndPopup.vue'),
    PerformanceDebugger: devEnv
      ? () => import('@/components/performance-debugger-ui/PerformanceDebugger.vue')
      : undefined,
  },
  data() {
    return {
      authUser: {} as any,
      currentLocationId: '',
      collapseSideBarValue: false,
      disableWM: false,
      customScripts: {
        style: undefined as string | undefined,
        js: undefined as any
      },
      emitter: useEmitter(),
      showUpgradeModal: false,
      upgradeModalSource: '',
      upgradeModal: null,
      showTrialEndPopup: false,
      isDev: devEnv,
      showPerformanceDebugger: false
    }
  },
  async created() {
    this.$store.dispatch('init')
    this.authUser = await this.$store.dispatch('auth/get')
    if ((this.$route.name === 'login_page' || this.$route.name === 'login') && window.pendo) {
      window.pendo.clearSession()
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    if (this.authUser && this.authUser.companyId) {
      await this.getPromoterLeadCount(this.authUser.companyId)
    }

  },
  computed: {
    loaderIsActive() {
      return this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive
    },
    isUserSwitching() {
      return this.$store.getters['auth/isUserSwitching'];
    },
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    ...mapState('locations', ['locations']),
    collapseSideBar() {
      return this.$store.getters.getManualCollapseSidebar
    },
    ...mapState('iframe', {
      iframe: (s: IframeState) => {
        return s.iframe ? new Iframe(s.iframe) : undefined
      },
    }),
    isV2SideBarEnabled() {
      return this.$store.getters['sidebarv2/getVersion'] == 'v2'
    },
    classes() {
      let classes = ''
      classes += this.collapseSideBar && this.$route.params.location_id
        ? `pmd-app ${this.$route.params.location_id}`
        : `${this.$route.params.location_id}`
      classes += this.isV2SideBarEnabled ? ' flex' : ''
      classes += this.collapseSideBar ? ' v2-collapse' : ' v2-open'
      classes += ` ${this.v2Id}`
      return classes
    },
    v2Id() {
      if (!this.$route.params.location_id) {
        if (this.$route.name === 'account_team_management') {
          return this.isV2SideBarEnabled ? 'sidebar-v2-agency sidebar-v2-agency-padding' : ''
        }
        return this.isV2SideBarEnabled ? 'sidebar-v2-agency' : ''
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute && !this.isOnbording ? 'sidebar-v2-location' : ''
      }
    },
    isV2SideBarRoute() {
      return this.$route.path.includes('/v2/location')
    },
    v2SideBarStyles() {
      if (!this.$route.params.location_id) {
        return this.isV2SideBarEnabled ? 'padding-top: 0px !important; overflow: hidden; height: 100vh; width: 100%;' : ''
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute ? 'padding-top: 0px !important; overflow: hidden; height: 100vh;' : ''
      }
    },
    isOnbording() {
      return this.$router.currentRoute.query.onboarding && this.$router.currentRoute.query.onboarding == 'true'
    },
    isInternalUser() {
      return this.$store.state.user.internalUser
    },
    userAndCompany() {
      return !!this.user && !!this.company
    },
    showTermsOfService() {
      return this.company && this.user && !this.isInternalUser && this.company.termsOfServiceVersion &&
        this.company.termsOfServiceVersion !== config.tosVersion
    },
    isMediaFilesEnabled() {
      return this.$route.name === 'template_library_admin' || this.$route.name === 'default-emails' || this.$route.name === 'saas-builder-labs'
    },

  },
  provide: function () {
    return {
      uxmessage: this.uxmessage,
    }
  },
  watch: {
    '$route.params.location_id': function (id) {
      setSentryMeta({ userId: get(this.user, 'id'), companyId: get(this.user, 'companyId'), locationId: id, email: get(this.user, '_data.email'), locale: localStorage.getItem(localizationKey) || Languages.English_US })
      this.initPendo();
      if (this.$route.params.location_id) {
        this.currentLocationId = id
        this.disableWM = true
      } else {
        this.disableWM = false
      }
    },
    user: function (newUser, oldUser) {
      this.initPendo();
      if (!oldUser && newUser) {
        if (
          newUser.type === 'agency'
        ) {
          this.identifyCanny();
        }
        setSentryMeta({ userId: get(this.user, 'id'), companyId: get(this.user, 'companyId'), locationId: get(this.$route, 'params.location_id'), email: get(this.user, '_data.email'), locale: localStorage.getItem(localizationKey) || Languages.English_US })
      }
              if (!newUser && oldUser) {
          Sentry.setUser(null);
        }
    },
    company: async function (newCompany, oldCompany) {
      this.initPendo();
      this.identifyCanny();
      const isCompanyChanged =   oldCompany && newCompany && oldCompany._id != newCompany._id
      if (!oldCompany && newCompany || isCompanyChanged) {

        if (newCompany.logoURL) {
          $('link[rel="icon"]').attr('href', newCompany.logoURL)
        }
        if (newCompany.name) {
          $('head').append(`<title>${newCompany.name}</title>`)
        }
        await this.getCustomScripts(newCompany?._id)
        if (!(window as any).exposeSessionDetails) {
          (window as any).exposeSessionDetails = this.exposeSessionDetails;
        }
        if (!(window as any).AppUtils) {
          this.getAppUtils()
        }
        let jsParams = {}
        if (this.user) {
          jsParams = { user: this.user, userId: this.user.id }
        }
        else if (!this.user) {
          const user = await this.$store.dispatch('user/get')
          jsParams = { user, userId: user.id }
        }
        if (isCompanyChanged) {
          const customJs = document.querySelector("#customJS");
          if (customJs) {
            customJs.innerHTML = "";
          }
          let customCSS = document.querySelector("#customCss");
          if (customCSS) {
            customCSS.innerHTML = "";
          }
          const customJsContainer = document.querySelector("#custom-js-integrations");
          if (customJsContainer) {
            customJsContainer.innerHTML = "";
          }
          let customCssContainer = document.querySelector(
            "#custom-style-marketplace-integrations"
          );
          if (customCssContainer) {
            customCssContainer.innerHTML = "";
          }

        }
        if (newCompany && newCompany.customJavascript) {
          // Sentry.getCurrentHub().getClient() tells if sentry is initialized or not.
          // But thats not needed as Sentry.close() will close it.
          Sentry.close(1000).then(() => {
            customLogger({message: 'sentry_session_closed', level: 'info', excludeFromSentry: true, tags: {
              file: 'PMDApp.vue',
              reason: 'Due to custom script',
            }})
          })
          const customJsContainer = document.querySelector('#customJS')
          if (customJsContainer) {
            customJsContainer.innerHTML = ''
          }
          try {
            postscribe(
              '#customJS',
              handlebars.compile(newCompany.customJavascript)(jsParams, {
                allowProtoPropertiesByDefault: true,
              }),
              {
                done: function () {
                  const customJavascript = newCompany.customJavascript
                  if (
                    customJavascript.includes('birdseed') ||
                    customJavascript.includes('helpwise')
                  ) {
                    const evt = document.createEvent('Event')
                    evt.initEvent('load', false, false)
                    window.dispatchEvent(evt)
                  }
                },
              }
            )
          } catch (err) {
            console.log('Error in custom JS processing', err)
          }
          // } else {
          //   if (
          //     ['app.gohighlevel.com', 'localhost:8080'].indexOf(location.host) !==
          //     -1
          //   ) {
          //     /*<![CDATA[*/
          //     window.groove = window.groove || {}
          //     groove.widget = function() {
          //       groove._widgetQueue.push(Array.prototype.slice.call(arguments))
          //     }
          //     groove._widgetQueue = []
          //     groove.widget('setWidgetId', '44231df8-7404-ffad-6a81-3f534fd3b329')
          //     !(function(g, r, v) {
          //       var a,
          //         n,
          //         c = r.createElement('iframe')
          //       ;((c.frameElement || c).style.cssText =
          //         'width: 0; height: 0; border: 0'),
          //         (c.title = ''),
          //         (c.role = 'presentation'),
          //         (c.src = 'javascript:false'),
          //         r.body.appendChild(c)
          //       try {
          //         a = c.contentWindow.document
          //       } catch (i) {
          //         n = r.domain
          //         var b = [
          //           "javascript:document.write('<he",
          //           'ad><scri',
          //           'pt>document.domain=',
          //           '"',
          //           n,
          //           '";</scri',
          //           'pt></he',
          //           'ad><bo',
          //           'dy></bo',
          //           "dy>')"
          //         ]
          //         ;(c.src = b.join('')), (a = c.contentWindow.document)
          //       }
          //       var d = 'https:' == r.location.protocol ? 'https://' : 'http://',
          //         s = 'http://groove-widget-production.s3.amazonaws.com'.replace(
          //           'http://',
          //           d
          //         )
          //       ;(c.className = 'grv-widget-tag'),
          //         (a.open()._l = function() {
          //           n && (this.domain = n)
          //           var t = this.createElement('script')
          //           ;(t.type = 'text/javascript'),
          //             (t.charset = 'utf-8'),
          //             (t.async = !0),
          //             (t.src = s + '/loader.js'),
          //             this.body.appendChild(t)
          //         })
          //       var p = ['<bo', 'dy onload="document._l();">']
          //       a.write(p.join('')), a.close()
          //     })(window, document)
          //     /*]]>*/
          //   }
        }

        if (newCompany && newCompany.customCSS) {
          let customCSS:any = document.querySelector('#customCss')
          if (customCSS) {
            customCSS.innerHTML = ''
          }else{
            customCSS = document.createElement('style')
            customCSS.id= "customCss"
          }
          customCSS.type = 'text/css'
          customCSS.media = 'screen'
          customCSS.appendChild(document.createTextNode(newCompany.customCSS))
          document.head.appendChild(customCSS)
        }
        //Custom Scripts from Marketplace
        if (this.customScripts?.length) {
          const customJsContainer = document.querySelector('#custom-js-integrations')
          if (customJsContainer) {
            customJsContainer.innerHTML = ''
          }
          const customCssStyles = document.querySelectorAll('style[id^="custom-style-marketplace-integrations"]')
          if (customCssStyles?.length) {
            customCssStyles.forEach(style => style.remove())
          }
          Object.values(this.customScripts)?.forEach((script: any) => {
            if (script?.customJS?.length) {
              const newDiv = document.createElement('div');
              newDiv.id = script?.id
              const node = document.querySelector('#custom-js-integrations')?.appendChild(newDiv)
              if (node) {
                try {
                  postscribe(
                    `#${script?.id}`,
                    handlebars.compile(script?.customJS)(jsParams, {
                      allowProtoPropertiesByDefault: true,
                    }),
                    {
                      afterAsync: function () {
                        const customJavascript = script?.customJS
                        if (
                          customJavascript.includes('birdseed') ||
                          customJavascript.includes('helpwise')
                        ) {
                          const evt = document.createEvent('Event')
                          evt.initEvent('load', false, false)
                          window.dispatchEvent(evt)
                        }
                      },
                    }
                  )
                } catch (err) {
                  console.log(`Custom JavaScript Failed for id: ${script?.id}`, err?.message, err)
                }
              }

            }
            if (script?.customCSS?.length) {
              const customCSS = document.createElement('style')
              customCSS.type = 'text/css'
              customCSS.media = 'screen'
              customCSS.id = `custom-style-marketplace-integrations-${script?.id}`
              customCSS.appendChild(document.createTextNode(script.customCSS))
              document.head.appendChild(customCSS)
            }
          })
        }

        if (newCompany && newCompany.theme) {
          document.body.dataset.theme = newCompany.theme
        } else if (this.isV2SideBarEnabled && !newCompany.theme) {
          document.body.dataset.theme = 'default-dark-v1'
        }

      }
    },
    userAndCompany: function (newValue) {
      if (newValue && this.user.type === 'agency') {
        let datePurchase = this.company.billingInfo?.first_payment_date ? moment(this.company.billingInfo?.first_payment_date?.seconds * 1000).format('MMM DD, YYYY HH:mm') : ''
        let daySincePurchase = this.company.billingInfo?.first_payment_date ? moment().diff(this.company.billingInfo?.first_payment_date?.seconds * 1000, 'days') : ''
        let firstImplementationCallDate = this.company.onboardingInfo.meta_data?.first_implementation_call_date ? moment(this.company.onboardingInfo.meta_data?.first_implementation_call_date?.seconds * 1000).format('MMM DD,YYYY') : '' || ""
        let implementationCSR1 = this.company.onboardingInfo.meta_data?.implementation_csr_1 || ""
        let firstCaptureCallDate = this.company.onboardingInfo.meta_data?.first_capture_call_date ? moment(this.company.onboardingInfo.meta_data?.first_capture_call_date?.seconds * 1000).format('MMM DD,YYYY') : '' || ""
        companyData = {
          id: this.company.id,
          name: this.company.name || '',
          email: this.company.email || '',
          status: this.company.status || '',
          activePlan: this.company.stripeActivePlan || '',
          created: moment(this.company.dateAdded).format('MMM DD, YYYY'),
          relationshipNumber: this.company.relationshipNumber,
          prioritySupport: this.company.premiumUpgraded || (this.company.jumpstartSupported && this.company.jumpstartSupported.seconds * 1000 >= +new Date()) || false,
          datePurchase: datePurchase,
          daySincePurchase: daySincePurchase,
          firstImplementationCallDate: firstImplementationCallDate,
          implementationCSR1: implementationCSR1,
          firstCaptureCallDate,
          stripeId: this.company.stripeId,
          locationCount: this.company.locationCount || 0,
        }
        userData.id = this.user.id
        userData.name = this.user.name
        userData.email = this.user.email
        userData.phone = this.user.phone
        this.$store.dispatch('freshchat/syncUserData', userData)
        this.$store.dispatch('freshchat/syncCompanyData', companyData)
        if (localStorage.getItem('proxyLoadSupport')) {
          loadFreshChatWidgetScript().then(() => {
            loadFreshWorksWidgets()
          })
        }
      }
      if(newValue){
        if (this.company?.billingInfo?.trial_end_date && this.user.type==='agency' && this.user.role==='admin' ) {
          const isAgencyInTrial = this.company.status === 'active_trial' || this.company.status === 'active_trial-extension'
          const trialEndDate = moment.unix(this.company.billingInfo.trial_end_date.seconds)
          const hasJoinedKickoffCall = this.company?.onboardingInfo?.hasJoinedKickoffCall
          const daysLeft = trialEndDate.diff(moment(), 'days')
          const isTrialEndPopupClosed = localStorage.getItem(`trial-end-popup-closed-${this.company?.id}`)==='true'
          const isOnboardingPending = this.company.onboardingInfo.pending

          if (
            daysLeft <= 4 &&
            !hasJoinedKickoffCall &&
            !isTrialEndPopupClosed &&
            isAgencyInTrial &&
            isOnboardingPending === false
          ) {

            this.loadTrialEndPopup()
          }
        }
      }
    }
  },
  methods: {
    uxmessage(item: Ux.UxMessage, toastIt: boolean = false) {
      if (toastIt) this.$refs['UxToast'].show(item)
      else this.$refs['UxMessageModal'].show(item)
    },
    refreshTimer() {
      var _self = this
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        _self.signout()
      }, 30 * 60 * 1000)
    },
    async signout() {
      try {
        await this.$store.dispatch('auth/signOutFromBackend')
        await this.$store.dispatch('logout')
        await firebase.auth().signOut()
      } catch (err) { }
      this.$router.push({ name: 'login' })
    },
    isAgencyOwner() {
      return this.user?.type === userType.AGENCY && (this.user?._data?.is_agency_owner || this.user?._data?.isAgencyOwner)
    },
    async initPendo(init = false) {
      try {
        if (config.mode !== 'production') {
          return
        }

        if (!this.user || !this.company) {
          // initializing with blank object.
          // window.pendo && window.pendo.initialize({});
          return;
        }
        let companyPreviousTools = {};
        if (this.company && this.company.onboardingInfo && this.company.onboardingInfo.tools) {
          for (let prevTool of this.company.onboardingInfo.tools) {
            companyPreviousTools[`prev_tool_${prevTool}`] = true;
          }
        }



        let conditionBasedParentAccProperties = {}
        if (this.company.onboardingInfo.meta_data?.first_implementation_call_date) {
          conditionBasedParentAccProperties['first_implementation_date'] = moment(this.company.onboardingInfo.meta_data?.first_implementation_call_date.seconds * 1000).toISOString()
        }
        if (this.company.onboardingInfo.meta_data?.implementation_csr_1) {
          conditionBasedParentAccProperties['implementation_csr_1'] = this.company.onboardingInfo.meta_data?.implementation_csr_1
        }
        if (this.company.onboardingInfo.meta_data?.first_capture_call_date) {
          conditionBasedParentAccProperties['first_capture_date'] = moment(this.company.onboardingInfo.meta_data?.first_capture_call_date.seconds * 1000).toISOString()
        }
        if (this.company.onboardingInfo.meta_data?.capture_csr) {
          conditionBasedParentAccProperties[`capture_csr`] = this.company.onboardingInfo.meta_data?.capture_csr
        }
        if (this.company.billingInfo?.first_payment_date) {
          conditionBasedParentAccProperties['date_purchase'] = moment(this.company.billingInfo?.first_payment_date?.seconds * 1000).toISOString()
        }

        if (this.company.locationCount || this.company.locationCount === 0) {
          conditionBasedParentAccProperties['location_count'] = this.company.locationCount
        }

        let pro_plus_status: null | String = null
        if (this.company && this.company.billingInfo && this.company.billingInfo.agency_pro_addon && this.company.billingInfo.agency_pro_addon.is_active) {
          let planLabel = this.company.billingInfo.agency_pro_addon.agency_pro_addon_active_plan
          pro_plus_status = planLabel === AgencyproPlusAddonPlan.Monthly ? 'pro_plus_addon_monthly_399' : 'pro_plus_addon_annual_399'
        }
        // console.log(this.user.dateAdded);
        let trialEndDate = this.company?.billingInfo?.end_trial_early?.trial_ended_on ? moment(this.company.billingInfo?.end_trial_early?.trial_ended_on.seconds * 1000).toISOString() : this.company?.billingInfo?.trial_end_date ? moment(this.company.billingInfo?.trial_end_date.seconds * 1000).toISOString() : ''
        let locationId = this.$route.params.location_id || '';
        let initObject = {
          visitor: {
            id: this.user?.id,                        // Required if user is logged in
            email: this.user?.email || '',            // Recommended if using Pendo Feedback, or NPS Email
            full_name: this.user?.fullName || '',     // Recommended if using Pendo Feedback
            role: this.user?.role,                    // Optional
            type: this.user?.type,
            is_agency_owner: this.isAgencyOwner() || false, //Defines whether the current user is an agency owner or not
            date_created: (this.user?._data.date_added?.seconds) ? moment(this.user._data.date_added.seconds * 1000).toISOString() : '',
            company_id: this.user?.companyId || '',
            phone: this.user?.phone || '',
            // location_id:

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
          },
          parentAccount: {
            id: this.company.id,
            name: this.company.name,
            email: this.company.email,
            status: this.company.status || '',
            phone: this.company.phone || '',
            active_plan: this.company.stripeActivePlan || '',
            created: moment(this.company.dateAdded).toISOString(),
            is_hippa_enabled: this.company.hipaaStatus || false,
            agency_primary_use: this.company.agencyPrimaryUse || '',
            business_niche: this.company.businessNiche || '',
            business_category: this.company.businessCategory || '',
            business_affinity_group: this.company.businessAffinityGroup || '',
            fp_lead_exists: leadCount === 0 ? false : true,
            customer_count: customerCount,
            is_paid_customer: this.company.billingInfo?.first_payment_date ? true : false,
            trial_start_date: moment(this.company.dateAdded).toISOString(),
            trial_end_date: trialEndDate,
            is_priority_support_enabled: this.company.premiumUpgradeStatus || false,
            is_jumpstart_support_enabled: this.company.jumpstartSupported ? this.company.jumpstartSupported.seconds * 1000 >= +new Date() : false,
            is_whitelabel_app_enabled: this.company.whitelabelAppStatus || '',
            is_terms_of_service_accepted: this.company.termsOfServiceVersion == config.tosVersion,
            terms_of_service_accepted_by: this.company.termsOfServiceAcceptedBy,
            terms_of_service_accepted_date: this.company.termsOfServiceAcceptedDate ? moment(this.company.termsOfServiceAcceptedDate).toISOString() : "",
            experiance_nps_enabled: this.company.experianceNpsEnabled,
            experiance_guides_enabled: this.company.experianceGuidesEnabled,
            experiance_reports_enabled: this.company.experianceReportsEnabled,
            country: this.company.country || '',
            relationship_number: this.company.relationshipNumber || '',
            agency_stripe_customer_id: this.company.stripeId,
            agency_stripe_subscription_id: this.company.stripeSubscriptionId,
            is_ag_twilio_isv_enabled: this.company.inIsvMode,
            is_ag_twilio_pure_isv_enabled: this.company.inPureIsvMode,
            has_invalid_billing_address: this.company.billingInfo?.has_invalid_billing_address || false,
            // OnboardingInfo
            customer_success_rep: this.company.onboardingInfo.meta_data?.customer_success_rep || "",
            first_onboarding_call_booked_on: this.company.onboardingInfo.meta_data?.first_onboarding_call_booked_on || "",
            first_onboarding_call_completed: this.company.onboardingInfo.meta_data?.first_onboarding_call_completed || "",
            second_onboarding_call_booked_on: this.company.onboardingInfo.meta_data?.second_onboarding_call_booked_on || "",
            second_onboarding_call_completed: this.company.onboardingInfo.meta_data?.second_onboarding_call_completed || "",

            //HL survey
            pa_usage_saass: this.company.hl_survey_values?.includes['saas'],
            pa_usage_client_business: this.company.hl_survey_values?.includes['client_business'],
            pa_usage_own_business: this.company.hl_survey_values?.includes['own_business'],
            pa_usage_all: this.company.hl_survey_values?.length === 3,

            whitelabel_domain: this.company.domain || '',
            stripe_connect_id: this.company.stripeConnectId || '',
            pro_plus_status,
            ...companyPreviousTools,
            ...conditionBasedParentAccProperties,

            // Optional
            // You can add any additional master account level
            // key-values here.
          },
        }
        if (this.company?.data?.hasOwnProperty('has_lc_email')) {
          initObject['parentAccount']['has_lc_email'] = this.company.data.has_lc_email
        }
        if (locationId) {
          let locationData = this.$store.getters['locations/getById'](locationId);
          if (!locationData) {
            return;
          }
          // https://support.pendo.io/hc/en-us/articles/360032201831-Managing-multiple-level-accounts
          initObject['account'] = {
            id: `${this.company.id}::${locationId}`,   // Highly recommended
            name: locationData.name,
            is_saas_enabled: locationData?.settings?.saas_settings?.saas_mode || false,
            company_id: locationData.company_id,
            date_created: moment(locationData.date_added).toISOString(),
            date_updated: moment(locationData.date_updated).toISOString(),
            country: locationData?.country,
            is_fb_page_connected: locationData.facebook_page_id ? true : false,
            // is_loc_twilio_isv_enabled: is_loc_twilio_isv_enabled // Handled seperatelly.
            // Optionalsrc/pmd/utils/CustomScriptHelper
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            niche: locationData?.niche_option?.niche,
            phone: locationData?.phone,
            email: locationData?.email || '',
            website: locationData?.website || '',
            platform_language: locationData?.locale_settings?.platform || "en_US",
            outbound_communication_language: locationData?.locale || "",

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
          }

          if (locationData?.google_places_id || locationData?.gmb?.places_id) {
            initObject['account']['is_gmb_page_connected'] = true
          }
          if (locationData?.settings?.email_isv_settings?.hasOwnProperty('has_lc_email')) {
            initObject['account']['has_lc_email'] = locationData.settings.email_isv_settings.has_lc_email
          }
          let isvLocationsRaw = localStorage.getItem('isv_locations');
          if (isvLocationsRaw) {
            let isvLocations = JSON.parse(isvLocationsRaw);
            if (isvLocations && isvLocations[locationId] !== undefined) {
              initObject['account']['is_loc_twilio_isv_enabled'] = isvLocations[locationId];
            }
          };
          try {
            const locationMetaContent = await this.$store.dispatch(
              'locations/fetchLocationMetaContent',
              { locationId }
            );
            if (locationMetaContent.pendoAccountData?.whatsapp?.hasWhatsApp) {
              initObject['account']['has_whatsapp'] = locationMetaContent.pendoAccountData.whatsapp.hasWhatsApp
            }
            if (locationMetaContent.pendoAccountData?.wordpress?.hasWordPress) {
              initObject['account']['has_wordpress'] = locationMetaContent.pendoAccountData.wordpress.hasWordPress
            }
            if (locationMetaContent.pendoAccountData?.wordpress?.wordpressAgencyPlan) {
              initObject['account']['wordpress_agency_plan'] = locationMetaContent.pendoAccountData.wordpress.wordpressAgencyPlan
            }
            if (locationMetaContent.pendoAccountData?.wordpress?.totalWordPressSubscriptions) {
              initObject['account']['wordpress_subscription_count'] = locationMetaContent.pendoAccountData.wordpress.totalWordPressSubscriptions
            }
            if (locationMetaContent.pendoAccountData?.wordpress?.totalWordPressSites) {
              initObject['account']['wordpress_sites_count'] = locationMetaContent.pendoAccountData.wordpress.totalWordPressSites
            }

            if (locationMetaContent.pendoAccountData?.funnel?.domainCount) {
              initObject['account']['funnel_domain_count'] = locationMetaContent.pendoAccountData.funnel.domainCount
            }
            // Yext Pendo Data
            const yextPendoData = locationMetaContent?.pendoAccountData?.yext
            initObject['account']['has_yext'] = yextPendoData?.hasYext === 'true' || false
            if (yextPendoData?.numberOfYextLocations) {
              initObject['account']['number_of_yext_locations'] = yextPendoData?.numberOfYextLocations
            }
          } catch (error) {
          }
          try {
            const twilioAccount = await this.$store.dispatch(
              'twilioAccount/getByLocationId',
              { locationId }
            );
            if (twilioAccount?.underGHLAccount) {
              initObject['account']['has_lc_phone'] = true
            }
            if (Object.keys(twilioAccount?.numberMeta).length) {
              const has_tollfree = Object.values(twilioAccount.numberMeta).some(({ numberType, countryCode }) => (numberType === "tollFree" && countryCode === "US"));
              const has_us_10dlc = !has_tollfree && Object.values(twilioAccount.numberMeta).some(({ numberType }) => (countryCode === "US" && (numberType === "local" || numberType === "mobile")));
              initObject['account']['has_tollfree'] = has_tollfree;
              initObject['account']['has_us_10dlc'] = has_us_10dlc;
            }
          } catch (error) {
          }
        }
        let isInternalUser = window.localStorage.getItem('is_internal_user');
        if (isInternalUser === 'true') {
        } else if (config.mode === 'production' || config.mode === 'staging') {
          if (init) {
            window.pendo && window.pendo.initialize(initObject)
          } else {
            window.pendo && window.pendo.identify(initObject)
          }
        } else {
          console.log('PENDO Object [only in dev mode]', initObject, 'is-init', init)
        }
      } catch (err) {
        console.log('Pendo INIT Failed !!', err)
      }
    },
    identifyCanny() {
      try {
        if (!this.user || !this.company || !window.Canny || (this.user && this.user.type == 'account')) {
          return;
        }
        Canny('identify', {
          appID: '612f76b3a11bf815b4eb024b',
          user: {
            companies: [{
              created: moment(this.company.dateAdded).toISOString(),
              id: this.company.id, //agencyid required
              monthlySpend: this.company.stripeActivePlan ? parseInt(this.company.stripeActivePlan.split('_')[2]) : 0, // required 97/297/497
              name: this.company.name, // required agency name
              customFields: {
                activePlan: this.company.stripeActivePlan || '',
                status: this.company.status || '',
                country: this.company.country || '',
                relationship_number: this.company.relationshipNumber || '',
                customer_success_rep: this.company.onboardingInfo.meta_data?.customer_success_rep || '',
                // agency_type: 'b2b/ saas/ own customer', // bhaibab
              },
            }],

            created: moment(this.user?._data?.date_added?.seconds * 1000).toISOString(),
            email: this.user?.email || '',
            id: this.user?.id || '',
            name: this.user?.fullName || '',
            customFields: {
              user_role: this.user?.role,
              user_type: this.user?.type,
            },
          },
        });
      } catch (err) {
        console.log('Canny Identify Failed !!', err)
      }
    },
    async getCustomScripts(companyId?:string) {
      try {
        if (this.user?.companyId ?? companyId) {
          const response = await IntegrationService.MarketplaceIntegrations.getCustomScripts(this.user?.companyId ?? companyId)
          if (response?.success) {
            this.customScripts = response?.scripts || []
          }
        }
      } catch (err) {
        console.error("Failed to fetch custom Scripts", err)
      }
    },
    async exposeSessionDetails(appId: number) {
      try {
        if (!appId) {
          console.error('AppId is required to expose session details')
          return
        }
        const res = await OauthService.getUserSessionJWT(appId, this.$router.currentRoute.params.location_id)
        return res.data
      } catch (error) {
        console.error('Failed to expose session details', error)
      }
    },
    // fetch lead and customer count of promoter by calling api
    async getPromoterLeadCount(companyId: string) {
      try {
        const promoterInfo = await AffiliateService.getPromoterInfo(companyId)
        if (promoterInfo && promoterInfo.length) {
          const promoter = promoterInfo[0]
          if (promoter && (promoter?.lifeTimeLead || promoter?.lifeTimeLead === 0)) {
            leadCount = promoter.lifeTimeLead
          }
          if (promoter && (promoter?.lifeTimeCustomer || promoter?.lifeTimeCustomer === 0)) {
            customerCount = promoter.lifeTimeCustomer
          }
        }
      }
      catch (error) {
        console.error('The error in getPromoterLeadCount', error)
      }
    },
    async loadUpgradeModal(source: string) {
      this.showUpgradeModal = false;
      this.upgradeModal = (await import('./components/agency/billing/UpgradeModalV3.vue')).default;
      this.showUpgradeModal = true;
      this.upgradeModalSource = source;
    },
    async loadTrialEndPopup() {
      this.showTrialEndPopup = true
    },
    getAppUtils(){
      try{
        const storage = new CustomStorageManager();
        (window as any).AppUtils = {Storage:storage, Utilities,RouteHelper};
      }catch(err){
        console.log(err)
      }
    },
    async cleanupCustomStorage(){
      try{
        const storage = new CustomStorageCleanUp();
        await storage.clear()
      }catch(err){
        console.log('cleanupCustomStorage failed: ',err)
      }
    },
    handleBeforeUnload (event) {
      localStorage.setItem('lastRefresh', new Date().toISOString())
    }
  },
  async mounted() {
    if (!String.prototype.replaceAll) {
      window.String.prototype.replaceAll = (str, match, replacement) => {
        return str.replace(new RegExp(match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), () => replacement);
      }
    }


    if (this.$route.name === 'login' && window.pendo) {
      window.pendo.clearSession();
    }
    if (this.$route.name === 'login_page' && window.pendo) {
      window.pendo.clearSession();
      window.localStorage.setItem('is_internal_user', 'true');
    }
    setTimeout(() => {
      this.initPendo(true)
    }, 3000);

    this.emitter.on('show-agency-plan-upgrade-modal', (data: { source: string }) => {
      this.loadUpgradeModal(data.source);
    })

    if (devEnv) {
      this.$root.$on('toggle-performance-debugger', () => {
        this.showPerformanceDebugger = !this.showPerformanceDebugger
      })

      const storedVisibility = localStorage.getItem('performance-debugger-visible');
      if (storedVisibility !== null && storedVisibility === 'true') {
        this.showPerformanceDebugger = true
      }
    }
  },
  async beforeDestroy() {
    await this.cleanupCustomStorage();
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    this.$root.$off('toggle-performance-debugger')
  }
})

Vue.filter('formatNumber', function (value: string | number) {
  if (!value) value = 0
  const locale = getCountryInfo('locale')
  return Number(value).toLocaleString(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })
})

Vue.filter('formatNumberNoDecimal', function (value: string | number) {
  if (!value) value = 0
  const locale = getCountryInfo('locale')
  return Number(value).toLocaleString(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })
})

Vue.filter('truncate', function (text: string, length?: number, clamp?: string) {
  text = text || ''
  clamp = clamp || '...'
  length = length || 30

  if (text.length <= length) return text

  var tcText = text.slice(0, length - clamp.length)
  var last = tcText.length - 1

  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0])
    last -= 1

  // Fix for case when text dont have any `space`
  last = last || length - clamp.length

  tcText = tcText.slice(0, last)

  return tcText + clamp
})

Vue.filter('capitalize', function (value: string) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('classify', function (value: string) {
  if (!value) return ''
  return value.toLowerCase().replaceAll(' ', '-')
})

Vue.filter('replaceStorageURL', function (value: string) {
  if (!value) return ''
  return value.indexOf('https://storage.cloud.google.com') === 0
    ? value.replace(
      'https://storage.cloud.google.com',
      'https://storage.googleapis.com'
    )
    : value
})

Vue.filter('toTitleCase', function (str: string) {
  if (str) {
    const words = str.toLowerCase().split(' ')
    for (var i = 0; i < words.length; i++) {
      if (words[i].charAt(0) === '(' && words[i].length > 1) {
        words[i] =
          words[i].charAt(0) +
          words[i].charAt(1).toUpperCase() +
          words[i].slice(2)
      } else {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
      }
    }
    return words.join(' ')
  }
})
Vue.filter('symbole', function (value: string) {
  return currencyList[value] || '$'
})

Vue.filter('str_limit', function (value, size) {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + '...';
});

